import { DOCS_URL } from "../../../config/constants.js";
import ServiceContactCta from "./ServiceContactCta.svelte";

export default {
    component: ServiceContactCta,
    name: "Service Contact CTA",
    description: "Bright yellow service page contact call to action",
    docsLink: `${DOCS_URL}/storybook/?path=/story/molecules-servicecontactcta--default`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/message-circle.svg",
    models: ["service-page"],
    inputs: [
        {
            friendlyName: "Text",
            name: "text",
            type: "string",
            defaultValue: "Speak to us about your brand’s Technical Strategy",
        },
        {
            friendlyName: "CTA Text",
            name: "ctaText",
            type: "string",
            defaultValue: "Contact us",
        },
        {
            friendlyName: "CTA Link",
            name: "ctaLink",
            type: "url",
            defaultValue: "#contact",
        },
        {
            friendlyName: "Images",
            name: "images",
            type: "list",
            subFields: [
                {
                    friendlyName: "Source",
                    name: "src",
                    type: "file",
                    allowedFileTypes: ["jpg", "jpeg", "png", "webp"],
                },
                { friendlyName: "Alt", name: "alt", type: "text" },
            ],
        },
    ],
};
